module.exports = __webpack_public_path__ + "officialStatic/img/case7.8264006.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/partner/case7.png
// module id = yPrz
// module chunks = 0